export default "__VITE_ASSET__BoWTvDg___"